import axios from 'axios'
import store from '../store'
import router from '../router'

let isTokenRefreshing = false

let client = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 150000,
  headers: {
    'Accept': 'application/json'
  }
})

client.interceptors.request.use((config) => {
  let accessToken = sessionStorage.getItem('access_token')

  if (accessToken) {
    config.headers['Authorization'] = 'Bearer ' + accessToken
  }

  return config
})

client.interceptors.response.use((response) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(response)
  }

  return response
}, (error) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(error)
  }

  if (typeof error.response !== 'undefined') {
    let originalRequest = error.config
    if (error.response.status === 401 && !isTokenRefreshing) {
      isTokenRefreshing = true
      return store.dispatch('refreshToken', {
        refresh_token: sessionStorage.getItem('refresh_token')
      })
        .then((response) => {
          originalRequest.headers['Authorization'] = 'Bearer ' + store.state.token
          return client(originalRequest)
        })
        .catch(() => {
          toastr.warning('Login scaduto')
          router.push('/login')
        })
    }

    if (error.response.status === 404) {
      originalRequest._retry = true
      router.push('/')
      return
    }

    if (error.response.status === 500) {
      toastr.error(error.response.data.message, 'Errore 500')
    }

    if (error.response.status === 422) {
      let errorMessage = ''
      for (let name in error.response.data.errors) {
        let errors = error.response.data.errors[name]
        for (let error in errors) {
          errorMessage += errors[error] + '<br>'
        }
      }
      toastr.error(errorMessage, 'Errore inserimento dati')
    }

    if (error.response.status === 400) {
      toastr.error(error.response.data.message, 'Errore 400')
    }
  } else if (typeof error.code !== 'undefined' && error.code === 'ECONNABORTED') {
    toastr.error('Connection aborted: ' + error.message)
  } else {
    toastr.error(error.message)
  }

  // Do something with response error
  throw error
})

export {
  client
}



// WEBPACK FOOTER //
// ./src/api/client.js